import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for button style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiButtonStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {
      whiteSpace: 'nowrap',
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[0],
      textTransform: 'none',
      height: 40,
      padding: '12px 44px',
      fontSize: 14,
      fontWeight: 500,
    },

    contained: {
      boxShadow: theme.shadows[0],
      backgroundColor: theme.palette.grey['100'],

      '&:hover': {
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[0],
      },

      '&$disabled': {
        backgroundColor: 'rgba(0,0,0,0.1)',
        color: theme.palette.common.white,
        boxShadow: theme.shadows[0],
      },
    },

    containedPrimary: {
      boxShadow: theme.shadows[0],

      '&:hover': {
        color: theme.palette.primary.contrastText,
        boxShadow: theme.shadows[0],
      },
    },

    // check if still necessary
    sizeSmall: {
      fontSize: 13,
      lineHeight: '34px',
      height: 34,
    },

    sizeLarge: {
      height: 42,
      lineHeight: '42px',
      fontSize: 15,
      padding: '0 30px',

      [theme.breakpoints.up('md')]: {
        height: 52,
        lineHeight: '52px',
        fontSize: 15,
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 16,
      },
    },

    containedSizeSmall: {
      padding: '0 15px',
    },

    startIcon: {
      marginLeft: -30,
      marginRight: 24,
    },

    endIcon: {
      marginRight: -30,
      marginLeft: 24,
    },
  };
};
